import { render, staticRenderFns } from "./PersonalizedSitesUpdateModal.vue?vue&type=template&id=5308820e&"
import script from "./PersonalizedSitesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./PersonalizedSitesUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedSitesUpdateModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports